import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface TechButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary';
  glow?: boolean;
  onClick?: () => void;
  className?: string;
}

export function TechButton({
  children,
  variant = 'primary',
  glow = false,
  onClick,
  className = '',
}: TechButtonProps) {
  const baseStyles = "px-6 py-3 rounded-lg font-display font-semibold transition-all duration-300 relative overflow-hidden";
  
  const variantStyles = {
    primary: "bg-accent-primary text-bg-primary hover:bg-accent-secondary",
    secondary: "bg-bg-elevated text-text-primary border border-accent-primary hover:border-accent-secondary",
    tertiary: "bg-transparent text-accent-primary border border-accent-primary/50 hover:border-accent-primary",
  };
  
  const glowClass = glow ? "shadow-[0_0_20px_rgba(88,166,255,0.5)] hover:shadow-[0_0_30px_rgba(88,166,255,0.7)]" : "";

  return (
    <motion.button
      className={`${baseStyles} ${variantStyles[variant]} ${glowClass} ${className}`}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.2 }}
    >
      <motion.span
        className="relative z-10"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.span>
      
      {/* Glow effect background */}
      {glow && (
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-accent-primary/20 to-accent-secondary/20 blur-xl"
          animate={{
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      )}
    </motion.button>
  );
}
